import { render, staticRenderFns } from "./PosterCreationNotification.vue?vue&type=template&id=d9fee46e"
import script from "./PosterCreationNotification.vue?vue&type=script&lang=js"
export * from "./PosterCreationNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports